var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H21",
    stroke: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H21",
    stroke: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H21",
    stroke: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIc);
export default __webpack_public_path__ + "static/media/burgerMenu_ic.e675d0a7a57f69e1dd0415b5231bf893.svg";
export { ForwardRef as ReactComponent };